import { z } from "zod";

export const UpdateUserPreferencesRequestSchema = z.object({
    preferences: z.record(z.any()),
});

export type UpdateUserPreferencesRequest = z.infer<typeof UpdateUserPreferencesRequestSchema>;
